var DateRange = /** @class */ (function () {
    function DateRange(range) {
        if (range) {
            this.from = range.from ? new Date(range.from) : undefined;
            this.to = range.to ? new Date(range.to) : undefined;
        }
    }
    DateRange.prototype.copy = function () {
        return new DateRange(this);
    };
    return DateRange;
}());
export { DateRange };
